import { render } from "./HelibaoAgreementDetails.vue?vue&type=template&id=33f0ca27&scoped=true"
import script from "./HelibaoAgreementDetails.vue?vue&type=script&lang=js"
export * from "./HelibaoAgreementDetails.vue?vue&type=script&lang=js"

import "./HelibaoAgreementDetails.vue?vue&type=style&index=0&id=33f0ca27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f0ca27"]])

export default __exports__